import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import { ViewVariant } from "@/common/ts/layout";
import { AssetDto, EntityType } from "@/core/api/generated/v1";

import GeneralHistoryPaginatedList from "../../../GeneralHistory/ListView/GeneralHistoryPaginatedList";

interface Props {
  asset: AssetDto;
}

export default function GeneralHistoryTabContent({ asset }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock>
        <GeneralHistoryPaginatedList
          defaultValues={{
            subjectEntityType: EntityType.Asset,
            subjectEntityId: asset.id,
          }}
          displayProps={{
            viewVariant: ViewVariant.Tab,
          }}
        />
      </ViewContentBlock>
    </PageTabContent>
  );
}
